import React from "react";
import { NavLink } from "react-router-dom";
import {
  FiHome, FiMessageSquare, FiTrendingUp, FiSettings,
  FiUsers, FiMail, FiShield, FiDatabase, FiZap, FiBarChart2,
  FiMenu, FiX
} from "react-icons/fi";

const navItems = [
  { label: "Dashboard", icon: <FiHome />, path: "/admin" },
  { label: "Messages", icon: <FiMessageSquare />, path: "/admin/messages" },
  { label: "SEO Management", icon: <FiTrendingUp />, path: "/admin/seo" },
  { label: "Customers & Leads", icon: <FiUsers />, path: "/admin/customers" },
  { label: "Marketing", icon: <FiMail />, path: "/admin/marketing" },
  { label: "Security & Privacy", icon: <FiShield />, path: "/admin/security" },
  { label: "CMS / SQL", icon: <FiDatabase />, path: "/admin/data" },
  { label: "Automations", icon: <FiZap />, path: "/admin/automations" },
  { label: "Analytics", icon: <FiBarChart2 />, path: "/admin/analytics" },
  { label: "Settings", icon: <FiSettings />, path: "/admin/settings" },
];

const AdminSidebar = ({ collapsed, onToggle }) => {
  return (
    <aside
      className={`${
        collapsed ? "w-20" : "w-64"
      } fixed top-0 left-0 h-screen bg-neutral-900 text-white shadow-xl flex flex-col py-6 px-4 transition-all duration-300 z-40`}
    >
      {/* Toggle Button */}
      <button
        className="mb-6 text-white hover:text-blue-400 transition self-end"
        onClick={onToggle}
        title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
      >
        {collapsed ? <FiMenu className="text-xl" /> : <FiX className="text-xl" />}
      </button>

      <nav className="flex flex-col space-y-3">
        {navItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            title={item.label}
            className={({ isActive }) =>
              `flex items-center gap-4 px-4 py-2 rounded-md transition-colors text-sm font-medium ${
                isActive
                  ? "bg-neutral-800 text-white"
                  : "text-gray-400 hover:text-white hover:bg-neutral-800"
              }`
            }
          >
            <span className="text-xl">{item.icon}</span>
            {!collapsed && <span className="whitespace-nowrap">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
